import { Box, Card, Typography } from '@mui/material';
import ColorChartThumbnail from '../components/charts/ColorChartThumbnail';

const LayoutCard = ({ layout, onClick }) => {
  return (
    <Card
      variant="outlined"
      onClick={onClick}
      sx={{
        p: 2,
        cursor: 'pointer',
        '&:hover': { boxShadow: 1 },
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
      }}
    >
      <Typography variant="h6" sx={{ mb: 1 }}>
        {layout.name}
      </Typography>
      {layout.steps &&
        layout.steps.map((row, rowIndex) => (
          <Box key={rowIndex} sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
            {row.steps && row.steps.map((step, colIndex) => <ColorChartThumbnail key={colIndex} data={step.data} colors={layout.colors} />)}
          </Box>
        ))}
    </Card>
  );
};

export default LayoutCard;
